export default __webpack_public_path__ + "img/earth.ef5bd2e9.png";